<template>
  <form>
    <div class="row">
      <div class="col-12 col-md-6 p-2">
        <label for="datepicker">{{
          t("username", {}, { locale: getLocal })
        }}</label>
        <div class="position-relative">
          <input
            disabled
            type="text"
            name="username"
            v-model="editData.username"
            class="form-control"
            :placeholder="t('username', {}, { locale: getLocal })"
          />
        </div>
      </div>
      <div class="col-12 col-md-6 p-2">
        <label for="datepicker">{{
          t("password", {}, { locale: getLocal })
        }}</label>
        <div class="position-relative">
          <input
            disabled
            type="text"
            name="password"
            v-model="editData.password"
            class="form-control"
            :placeholder="t('password', {}, { locale: getLocal })"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6 p-2">
        <label for="datepicker">{{
          t("name", {}, { locale: getLocal })
        }}</label>
        <div class="position-relative">
          <input
            type="text"
            name="name"
            v-model="editData.name"
            class="form-control"
            :placeholder="t('name', {}, { locale: getLocal })"
          />
        </div>
      </div>
      <div class="col-12 col-md-6 p-2">
        <label for="datepicker">{{
          t("mobile", {}, { locale: getLocal })
        }}</label>
        <div class="position-relative">
          <input
            type="text"
            name="mobile"
            v-model="editData.mobile"
            class="form-control"
            :placeholder="t('mobile', {}, { locale: getLocal })"
          />
        </div>
      </div>
    </div>
    <div class="button-group d-flex pt-25">
      <button
        @click="sendEditData($event)"
        class="btn btn-primary btn-default btn-squared text-capitalize"
      >
        {{ t("edituser", {}, { locale: getLocal }) }}
      </button>
    </div>
  </form>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
  name: "FormEditUserList",
  setup() {
    const { t, locale } = useI18n();
    return { t, locale };
  },
  data: function () {
    return {};
  },
  props: ["options", "editData"],
  computed: {
    getLocal: function () {
      return this.$store.getters["display/getLocal"];
    },
  },
};
</script>

<style>
</style>